import { render, staticRenderFns } from "./PlateGroups.vue?vue&type=template&id=b9e7e810&scoped=true"
import script from "./PlateGroups.vue?vue&type=script&lang=js"
export * from "./PlateGroups.vue?vue&type=script&lang=js"
import style0 from "./PlateGroups.vue?vue&type=style&index=0&id=b9e7e810&prod&lang=less"
import style1 from "./PlateGroups.vue?vue&type=style&index=1&id=b9e7e810&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e7e810",
  null
  
)

export default component.exports